<template>
  <section style="background-color: #093832">
    <div :style="HeroDecoration">
      <bl-flex-container-mv :gutter="20" align-items="center">
        <bl-flex-item-av :col="6">
          <bl-flex-container-mv direction="column" :gutter="24">
            <bl-flex-item-av>
              <div>
                <bl-text-av tag="h1" variation="heading-42" color="inverse" weight="bold" style="display: inline">
                  {{ $options.text.title.h1 }}
                </bl-text-av>
                <bl-text-av tag="span" variation="heading-42" color="inverse" weight="bold">
                  {{ $options.text.title.other }}
                </bl-text-av>
              </div>
            </bl-flex-item-av>
            <bl-flex-item-av>
              <bl-text-av style="font-size: 26px; line-height: 32px;" color="inverse">
                {{ $options.text.subtitle }}
              </bl-text-av>
            </bl-flex-item-av>
            <bl-flex-item-av>
              <register-button />
            </bl-flex-item-av>
          </bl-flex-container-mv>
        </bl-flex-item-av>

        <bl-flex-item-av :col="6">
          <new-webp-image-container
            src="img_medium_fun_money.png"
            alt="img_medium_fun_money"
            :is-ssr="isSSR"
            styles="max-width: 660px; max-height: 410px; width: 100%; height: 100%;"
          />
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import { assetURL } from 'shared/helpers/assetHelper';
import { Header as text } from 'shared/modules/seo/Homepage';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BlTextAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlFlexItemAv';
import RegisterButton from 'seo-desktop/components/RegisterButton';

export default {
  name: 'Header',

  text,

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    RegisterButton,
    NewWebpImageContainer,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },

    HeroDecoration() {
      return {
        padding: '80px 55px 43px',
        'background-repeat': 'no-repeat',
        'background-position': 'bottom left',
        'background-image': `url(${assetURL('hero_banner_desktop.png', this.isSSR)})`,
        'background-size': '100% 100%',
        height: '520px',
      };
    },
  },
};
</script>
